// extracted by mini-css-extract-plugin
export default {"image-gallery-container":"GalleryImageView_image-gallery-container__vbnhj","image-gallery-container__item":"GalleryImageView_image-gallery-container__item__bXrB9"};